/**
 * Polyfill
 */
import 'babel-polyfill'

/**
 *  Vue
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Vuex from 'vuex'

Vue.use(VueI18n)
Vue.use(Vuex)

window.Vue = Vue

import '../../admin/filters/datetime'
import '../filters/striptags'
import '../filters/locale-orderby'
import { messages, fetchTranslations } from '../../plugins/translations'


var lang = document.getElementsByTagName('html')[0].getAttribute('lang')

window.i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'cs',
  messages
})

fetchTranslations('front')

/**
 * AXIOS
 */
import axios from 'axios'
window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = EasyEvent.csrfToken

/**
 * dayjs.js - date formatting
 */
import 'dayjs/locale/cs'
import 'dayjs/locale/en'
import 'dayjs/locale/sk'
import 'dayjs/locale/de'
import 'dayjs/locale/fr'

import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.locale(lang)
window.dayjs = dayjs

/**
 * socket.io
 */
import io from 'socket.io-client';
window.io = io
window.socket = io.connect(websocketAddr, {
  timeout: 1000,
  reconnectionDelay: 500,
  reconnectionDelayMax: 500,
  transports: ['polling']
})
window.heartbeatCallback = null;
window.timestamp = new Date().getTime()
window.connectError = false;

setInterval(() => {
  let currTime = new Date().getTime()
  if (currTime > timestamp + 10000 || connectError) { // more than 10s asleep
    if (heartbeatCallback) heartbeatCallback()
  }
  window.timestamp = new Date().getTime()
}, 1000)

socket.on('connect', () => {
  connectError = false
})

socket.on('connect_timeout', () => {
  connectError = true
})

socket.on('connect_error', () => {
  connectError = true
})
